import { httpBus } from '@/api/httpBus/index.js'
import { elinks } from '@/views/station-monitor/detail/tabs/StrategyController/api.js'
import { getStationList } from '@/api/workbench/index.js'

// 目标树：eLink 懒加载复用现有接口
export { elinks }

/**
 * 分页获取业主电站（目标树懒加载/分页用，避免一次性拉全量导致卡顿）
 * @param {{ pageNum:number, pageSize:number, name?:string }} params
 * @returns {Promise<{ data: { list: Array, total: number } }>}
 */
export function getOwnerStationsPage(params) {
  return getStationList({
    pageNum: params.pageNum || 1,
    pageSize: params.pageSize || 30,
    name: params.name,
  })
}

// ====================== 策略模板（后端接口） ======================

const TEMPLATE_BASE = '/strategy/elink/strategy/template'

/** 我的模板列表（按 updated_time 倒序） */
export function listTemplates() {
  return httpBus.request('get', TEMPLATE_BASE)
}

/** 模板详情 */
export function getTemplateDetail(id) {
  return httpBus.request('get', `${TEMPLATE_BASE}/${id}`)
}

/** 新增模板（id/user_id/create_by/时间由后端生成） */
export function createTemplate(data) {
  return httpBus.request('post', TEMPLATE_BASE, { data })
}

/** 修改模板（必须带 id） */
export function updateTemplate(data) {
  return httpBus.request('put', TEMPLATE_BASE, { data })
}

/** 删除模板（物理删除） */
export function deleteTemplate(id) {
  return httpBus.request('delete', `${TEMPLATE_BASE}/${id}`)
}

/**
 * 批量下发（第一步）：把模板策略批量覆盖保存并推送到多个 elink
 * @param {{ template_id:string, targets:Array<{station_id,station_name,elink_id,elink_name}> }} data
 * @returns {Promise} data 为汇总对象 { total, dispatched, fail, traceing_nos, items:[...] }
 */
export function dispatchTemplate(data) {
  return httpBus.request('post', `${TEMPLATE_BASE}/dispatch`, { data })
}

/**
 * 查询下发回报结果（第二步）：把第一步返回的 items 原样传回
 * @param {Array} items 第一步返回的 items（含 traceing_no）
 * @returns {Promise} data 为结果数组
 */
export function dispatchResult(items) {
  return httpBus.request('post', `${TEMPLATE_BASE}/dispatch/result`, { data: items })
}
